(function(){
  // Mobile menu
  var hamb=document.getElementById('hamb'),mMenu=document.getElementById('mMenu'),mOv=document.getElementById('mOverlay');
  function closeM(){if(mMenu)mMenu.classList.remove('show');if(mOv)mOv.classList.remove('show');}
  if(hamb&&mMenu&&mOv){
    hamb.addEventListener('click',function(){mMenu.classList.toggle('show');mOv.classList.toggle('show');});
    mOv.addEventListener('click',closeM);
    mMenu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',closeM);});
  }

  // Collection filter chips (homepage only)
  var chips=document.querySelectorAll('.chip');
  if(chips.length){
    var prods=document.querySelectorAll('#prodGrid .prod'),emptyNote=document.getElementById('emptyNote');
    function applyFilter(cat){
      chips.forEach(function(c){c.classList.toggle('active',c.dataset.cat===cat);});
      var shown=0;
      prods.forEach(function(p){var ok=(cat==='all'||p.dataset.cat===cat);p.style.display=ok?'flex':'none';if(ok)shown++;});
      if(emptyNote)emptyNote.style.display=shown?'none':'block';
    }
    chips.forEach(function(c){c.addEventListener('click',function(){applyFilter(c.dataset.cat);});});
  }

  // Accordion policies
  document.querySelectorAll('.acc-head').forEach(function(h){
    h.addEventListener('click',function(){
      var item=h.parentElement,body=h.nextElementSibling,open=item.classList.contains('open');
      document.querySelectorAll('.acc-item').forEach(function(i){i.classList.remove('open');var b=i.querySelector('.acc-body');if(b)b.style.maxHeight=null;});
      if(!open){item.classList.add('open');body.style.maxHeight=body.scrollHeight+'px';}
    });
  });

  // Quantity stepper (product page)
  var qi=document.querySelector('[data-qty-input]');
  if(qi){
    var minus=document.querySelector('[data-qty-minus]'),plus=document.querySelector('[data-qty-plus]');
    if(minus)minus.addEventListener('click',function(){var n=parseInt(qi.value||'1',10);if(n>1)qi.value=n-1;});
    if(plus)plus.addEventListener('click',function(){var n=parseInt(qi.value||'1',10);qi.value=n+1;});
  }


  // Collection filter panel toggle
  var ftog=document.querySelector('[data-filter-toggle]'),fpanel=document.getElementById('filterPanel');
  if(ftog&&fpanel){ftog.addEventListener('click',function(){fpanel.classList.toggle('open');});}


  // Product image gallery
  var pdpMain=document.getElementById('pdpMainImg'),pthumbs=document.querySelectorAll('.pdp-thumb');
  function setMain(url){ if(pdpMain&&url){pdpMain.src=url;} }
  function markThumb(url){ pthumbs.forEach(function(t){ t.classList.toggle('active', t.getAttribute('data-full')===url); }); }
  if(pdpMain&&pthumbs.length){
    pthumbs.forEach(function(t){ t.addEventListener('click',function(){ var u=t.getAttribute('data-full'); setMain(u); markThumb(u); }); });
  }
  // Swap main image when a variant with its own image is selected
  var vsel=document.querySelector('select[name="id"]');
  if(vsel&&pdpMain){
    vsel.addEventListener('change',function(){
      var opt=vsel.options[vsel.selectedIndex], img=opt&&opt.getAttribute('data-img');
      if(img&&img.length>4){ setMain(img); markThumb(img); }
    });
  }

  // Reveal on scroll
  var rev=document.querySelectorAll('.reveal');
  if(rev.length&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1});
    rev.forEach(function(el){io.observe(el);});
  }else{rev.forEach(function(el){el.classList.add('in');});}
})();
